webpackJsonp([53],{

/***/ "QxZD":
/***/ (function(module, exports, __webpack_require__) {

var SectionVideoStatistics = (function () {
    function SectionVideoStatistics() {
    }
    return SectionVideoStatistics;
}());
angular.module('animatronApp.sectionVideoStatistics', []).component('sectionVideoStatistics', {
    bindings: {
        ltTitle: '<',
        statistics: '<'
    },
    controller: SectionVideoStatistics,
    templateUrl: __webpack_require__("Z0Ui")
});


/***/ }),

/***/ "Z0Ui":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/section-video-statistics_404858ab8fd51e259c3b56f932d44f4c.html";

/***/ })

});


// WEBPACK FOOTER //
// javascripts/53-28dc41a6a889e793a2e2.min.js